<template>
  <div>
    <v-menu style="z-index: 999">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-on:click.prevent
          v-bind="attrs"
          v-on="on"
          class="context-menu-btn-view-actions"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="(contextMenu, index) in contextMenusWithPermission"
          :key="index"
          :disabled="contextMenu.disabled"
          style="display: -webkit-box !important;"
          :class="{ 'context-menu-action-items': true, 'disabled': contextMenu.disabled }"
          @click="handleContextMenuClick(contextMenu.key)"
        >
          <v-list-item-icon>
            <v-icon :color="contextMenu.color">{{contextMenu.icon}}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ capitalizeFirstLetter($t(contextMenu.title)) }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'cdr-actions',
  props: {
    hasRec: {
      type: Boolean,
      required: true
    },
    cdr: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      contactsManagePersonal: 'permissions/contactsManagePersonal',
      contactsWrite: 'permissions/contactsWrite',
      currentUser: 'currentUser/currentUser',
      isOwnerCurUser: 'settings/isOwnerCurUser'
    }),
    contextMenusWithPermission: function () {
      const data = [
        { title: 'cdrs.btn.download', key: 'download', icon: 'mdi-download', color: !this.hasRec ? 'default' : 'blue-grey', disabled: !this.hasRec },
        { title: 'cdrs.btn.playrec', key: 'playrec', icon: 'mdi-play', color: !this.hasRec ? 'default' : 'primary', disabled: !this.hasRec },
        { title: 'cdrs.btn.callback', key: 'callback', icon: 'mdi-phone', color: !this.hasRec ? 'default' : 'green', disabled: false }
      ]
      if (this.contactsWrite) {
        data.push({ title: 'chat.contextMenu.add_shared_contact', key: 'add_shared_contact', icon: 'mdi-plus', color: 'default', disabled: this.currentUser?.extension !== this.cdr.fromNum ? isNaN(this.cdr.fromNum) : isNaN(this.cdr.toNum) })
      }
      if (this.contactsManagePersonal) {
        data.push({ title: 'chat.contextMenu.add_personal_contact', key: 'add_personal_contact', icon: 'mdi-plus', color: 'default', disabled: this.currentUser?.extension !== this.cdr.fromNum ? isNaN(this.cdr.fromNum) : isNaN(this.cdr.toNum) })
      }
      if (this.isOwnerCurUser) {
        data.push({ title: 'chat.contextMenu.add_blacklist', key: 'add_blacklist', icon: 'mdi-account-cancel', color: 'default', disabled: this.currentUser?.extension !== this.cdr.fromNum ? isNaN(this.cdr.fromNum) : isNaN(this.cdr.toNum) })
      }
      return data
    }
  },
  methods: {
    handleContextMenuClick (action) {
      switch (action) {
        case 'download': {
          this.$emit('download')
          break
        }
        case 'playrec': {
          this.$emit('playrec')
          break
        }
        case 'callback': {
          this.$emit('callback')
          break
        }
        case 'add_shared_contact': {
          this.$emit('addToContacts', { action: action, cdr: this.cdr })
          break
        }
        case 'add_personal_contact': {
          this.$emit('addToContacts', { action: action, cdr: this.cdr })
          break
        }
        case 'add_blacklist': {
          this.$emit('addBlacklist', this.cdr)
          break
        }
      }
    },
    capitalizeFirstLetter (string) {
      return string?.charAt(0).toUpperCase() + string?.slice(1)
    }
  }
}
</script>

<style scoped>
</style>
